/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Agent_Authorization_Pricing_FreemiumInputs */

const en_agent_authorization_pricing_freemium = /** @type {(inputs: Agent_Authorization_Pricing_FreemiumInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Freemium`)
};

const zh_agent_authorization_pricing_freemium = /** @type {(inputs: Agent_Authorization_Pricing_FreemiumInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`免费增值`)
};

/**
* | output |
* | --- |
* | "Freemium" |
*
* @param {Agent_Authorization_Pricing_FreemiumInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const agent_authorization_pricing_freemium = /** @type {((inputs?: Agent_Authorization_Pricing_FreemiumInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Agent_Authorization_Pricing_FreemiumInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_agent_authorization_pricing_freemium(inputs)
	return zh_agent_authorization_pricing_freemium(inputs)
});
export { agent_authorization_pricing_freemium as "agent.authorization.pricing.freemium" }